import { ObjectMapper } from 'json-object-mapper';
import { IModel } from 'services/models/IModel';
import { Model } from 'services/models/model';
import { IntegrationLinkTypeEnum } from 'services/enums/integrationLinkType.enum';

export class IntegrationLinkModel extends Model implements IModel<IntegrationLinkModel> {
  name: string = '';
  type: number = 0;
  companyGroupId: string = '';

  static create(input: any): IntegrationLinkModel {
    const model = ObjectMapper.deserialize<IntegrationLinkModel>(IntegrationLinkModel, input);
    model.type = IntegrationLinkTypeEnum.toId(input?.type ?? model.type) ?? 0;
    return model;
  }
}
